export const FETCH_END = 'setItems'
export const FETCH_END_INFINITE = 'setItemsInfinite'
export const FETCH_START = 'setLoading'
export const PURGE_AUTH = 'logOut'
export const SET_SHIPPING = 'setShipping'
export const SET_AUTH = 'setUser'
export const SET_COMMENTS = 'setComments'
export const SET_ERROR = 'setError'
export const SET_PROFILE = 'setProfile'
export const UPDATE_SHIPPING_IN_LIST = 'updateAricleInList'
export const RESET_STATE = 'resetModuleState'
export const SET_ITEM = 'setItem'
export const CLEAR_FAQ = 'clearFaq'
export const SET_ADDRESS = 'setAddress'
